//#region IMPORTS
import {
  setOrderParams,
  fetchOrdersAsync,
  fetchShippableOrdersAsync,
} from "./ordersSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import OrdersHandlingContainer from "../../components/ordersHandling/OrdersHandlingContainer";
//#endregion

export default function OrdersHandlingPage() {
  //#region SETUP
  // Router
  const history = useHistory();

  // Redux
  const dispatch = useAppDispatch();
  const { orders_loaded } = useAppSelector((state) => state.orders);
  const { limit, sort, page, include_sub_orders, ...params } = useAppSelector(
    (state) => state.orders.order_params
  );
  //#endregion

  //#region LOGIC
  // Redirect if required params are missing
  useEffect(() => {
    if (!params.order_status || !params.order_type) {
      dispatch(
        setOrderParams({
          limit: 25,
        })
      );
      history.replace("/orders");
    }
  }, [params]);

  // Load orders
  useEffect(() => {
    const fetchOnload = async () => {
      if (!orders_loaded) {
        await dispatch(fetchOrdersAsync());
        await dispatch(fetchShippableOrdersAsync());
      }
    };
    fetchOnload();
  }, [orders_loaded]);
  //#endregion

  //#region RENDER
  return <OrdersHandlingContainer title="Order handling" />;
  //#endregion
}
